export function updateQueryStringParameter(uri: string, key: string, value: string): string {
	const re:RegExp = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
	const separator: string = uri.indexOf('?') !== -1 ? '&' : '?';	
	if(re.exec(uri)) {
		return uri.replace(re, '$1' + key + '=' + value + '$2');
	}

	return uri + separator + key + '=' + value;
}
